import { Zip } from "@pdfking/tfunc"

export const zip = (...args) => [...Zip(...args)]
